import React from 'react';
import { Box, Skeleton } from '@mui/material';
import CollageImage from '@components/CollageImage';
import { ensureWebP } from '@utils/index';

const MainPageImage = ({
  collageImage,
  collageImageSmall,
  imageLarge,
  isLoading
}: {
  collageImage: string;
  collageImageSmall: string;
  imageLarge: string;
  isLoading: boolean;
}) => {
  const renderLoadingOrSkeleton = () => {
    const smallImageDimensions = { width: 600, height: 450 };
    const largeImageDimensions = { width: 1600, height: 1200 };

    if (!isLoading) {
      return null;
    }

    return (
      <Box
        margin="0 auto"
        sx={{
          maxWidth: {
            xs: '100%', // Full width on extra-small screens
            md: '80%' // 80% width on medium and larger screens
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            // Maintain aspect ratio based on screen size
            paddingBottom: {
              xs: `${
                (smallImageDimensions.height / smallImageDimensions.width) * 100
              }%`, // Small screen aspect ratio
              md: `${
                (largeImageDimensions.height / largeImageDimensions.width) * 100
              }%` // Large screen aspect ratio
            }
          }}
        >
          {/* Skeleton as a placeholder */}
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0
            }}
          />
        </Box>
      </Box>
    );
  };

  return (
    <>
      {collageImage && collageImageSmall ? (
        <CollageImage
          collageImage={ensureWebP(collageImage)}
          collageImageSmall={ensureWebP(collageImageSmall)}
        />
      ) : (
        renderLoadingOrSkeleton()
      )}
      {!collageImage && !collageImageSmall && imageLarge ? (
        <Box
          component="img"
          src={imageLarge}
          alt=""
          margin="0 auto"
          display="block"
          role="presentation"
          id="primaryImage"
          sx={{
            objectFit: 'cover',
            width: '100%',
            minWidth: '100%',
            minHeight: '100%'
          }}
        />
      ) : null}
    </>
  );
};

export default MainPageImage;
